import '../static/StatCard.css';
import React__default from "react";
import clsx from "clsx";
import { c as Heading } from "./Heading.D9qZoTZe.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import { b as TextLink } from "./TextLink.gdbulXZb.mjs";
import { C as Card } from "./Card.BpXboJlO.mjs";
const statCard = `_statCard_e682ccd`;
const row = `_row_dbc4451`;
const description = `_description_945196a`;
const link = `_link_dbffdf0`;
const styles = { statCard, row, description, link };
const StatCard = ({
  className,
  leadUnit,
  trailUnit,
  stat,
  description: description2,
  textLink,
  ...props
}) => {
  const { label, ...textLinkProps } = textLink || {};
  return /* @__PURE__ */ React__default.createElement(
    Card,
    {
      className: clsx(styles.statCard, className),
      "data-ui-solution-card": true,
      ...props
    },
    /* @__PURE__ */ React__default.createElement("p", { className: styles.row }, leadUnit && /* @__PURE__ */ React__default.createElement(Heading, { as: "span", size: "2xl", weight: "light", "data-testid": "leadUnit" }, leadUnit), /* @__PURE__ */ React__default.createElement(Heading, { as: "span", size: "3xl" }, stat), trailUnit && /* @__PURE__ */ React__default.createElement(Heading, { as: "span", size: "2xl", weight: "light", "data-testid": "trailUnit" }, trailUnit)),
    description2 && /* @__PURE__ */ React__default.createElement(Paragraph, { className: styles.description, "data-testid": "description" }, description2),
    (textLinkProps == null ? void 0 : textLinkProps.href) && /* @__PURE__ */ React__default.createElement(TextLink, { className: styles.link, ...textLinkProps, arrow: "right" }, label)
  );
};
export {
  StatCard
};
//# sourceMappingURL=StatCard.CLPZ8dPe.mjs.map
